/**
 * Authentication API Service
 *
 * Provides access to authentication endpoints for token retrieval.
 */

import { apiClient } from './api-client'

/**
 * Token response structure from auth API
 */
export interface TokenResponse {
    token: string
    expiresAt: string
    worker: {
        workerId: number
        name: string,
        avatar: string | null,
        bx_avatar: string | null
    }
}

/**
 * Fetches an authentication token for the specified worker
 *
 * @param workerId - The worker ID to authenticate
 * @returns Promise<TokenResponse> - Token and worker profile data
 * @throws Error if API request fails or worker not found (400, 404, 500)
 *
 * @example
 * ```typescript
 * const tokenData = await fetchAuthToken('123')
 * console.log(tokenData.token) // 'eyJhbGciOiJIUzI1NiIs...'
 * console.log(tokenData.worker.name) // 'John Doe'
 * ```
 */
export async function fetchAuthToken(workerId: number): Promise<TokenResponse> {
    return apiClient.post<TokenResponse>('/api/warden/auth/token', { workerId })
}
